module.exports = __webpack_public_path__ + "img/wallet.b12c41f5.png";